// Constantes compartidas del módulo de Promesas de Pago.

export const ESTADO_LABELS = {
  pendiente: 'Pendiente',
  cumplida: 'Cumplida',
  incumplida: 'Incumplida',
  cancelada: 'Cancelada',
  vencida: 'Vencida',
};

export const ESTADO_COLORS = {
  pendiente: 'warning',
  cumplida: 'success',
  incumplida: 'error',
  cancelada: 'default',
  vencida: 'error',
};

// Derivación de "vencida" cuando la promesa sigue en pendiente pero ya pasó la fecha.
export const computedEstado = (promesa) => {
  if (promesa.estado !== 'pendiente') return promesa.estado;
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const fecha = new Date(promesa.fecha_promesa);
  fecha.setHours(0, 0, 0, 0);
  return fecha < hoy ? 'vencida' : 'pendiente';
};
